import React from 'react';

export default function CatIcon() {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="840.000000pt"
      height="592.000000pt"
      viewBox="0 0 840.000000 592.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,592.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path
          d="M2844 5471 c-177 -81 -500 -615 -607 -1006 -14 -49 -28 -102 -31
-117 l-6 -27 -129 6 c-153 7 -181 2 -181 -32 0 -30 9 -33 163 -38 65 -2 120
-7 123 -10 5 -5 -14 -144 -19 -148 -1 -1 -69 -8 -152 -18 -138 -15 -150 -18
-153 -37 -6 -41 18 -47 141 -35 133 13 160 14 154 3 -3 -4 -13 -93 -22 -197
-21 -226 -16 -620 9 -805 30 -220 137 -602 232 -827 124 -297 358 -657 579
-892 279 -297 942 -690 1350 -801 114 -31 275 -38 349 -15 98 31 176 118 176
197 0 71 -44 135 -185 272 -75 72 -135 136 -135 141 0 6 19 16 43 23 23 7 84
33 135 58 l93 45 75 -66 c166 -145 372 -284 483 -326 133 -50 241 -71 393 -76
212 -8 338 23 480 116 182 119 325 346 344 548 18 198 -60 472 -169 590 -68
74 -140 92 -224 54 -84 -39 -92 -106 -34 -285 50 -155 58 -214 37 -295 -30
-117 -114 -214 -230 -267 -181 -83 -461 -22 -687 148 -72 54 -149 135 -149
156 0 6 16 43 35 83 19 41 42 106 52 144 10 39 19 72 20 74 1 2 30 -19 65 -46
182 -143 344 -223 453 -223 57 0 124 37 160 88 25 36 30 55 33 117 12 225
-177 509 -678 1020 -129 132 -265 278 -301 325 -80 102 -203 289 -196 296 3 3
25 0 48 -7 74 -20 179 -16 233 10 79 39 117 105 118 206 0 102 -40 172 -134
235 -95 63 -200 93 -338 94 -63 1 -128 -1 -145 -4 l-29 -5 -47 150 c-26 83
-48 155 -48 162 -1 16 113 52 189 61 71 8 94 28 70 57 -12 15 -26 16 -80 11
-37 -3 -93 -15 -125 -26 -77 -26 -80 -26 -92 15 -11 34 -10 36 20 52 18 9 75
30 127 47 72 24 96 36 99 50 7 40 -23 45 -109 21 -43 -13 -100 -33 -126 -44
-26 -12 -48 -20 -49 -19 -1 2 -11 28 -24 58 -30 75 -91 176 -139 230 l-39 45
13 75 c8 41 17 130 20 197 8 145 -6 202 -58 229 -84 44 -254 -47 -418 -223
l-70 -75 -108 18 c-63 11 -159 18 -233 19 l-127 0 -7 59 c-15 139 -70 301
-119 354 -48 53 -96 63 -162 33z m103 -73 c52 -58 100 -210 110 -354 3 -47 11
-88 18 -94 9 -7 30 -7 66 1 69 15 236 5 376 -22 l106 -20 84 91 c127 135 230
209 316 225 33 7 38 5 47 -20 16 -42 12 -165 -11 -311 l-20 -135 55 -60 c99
-110 143 -215 291 -694 26 -82 52 -156 59 -163 10 -10 23 -10 71 3 143 37 336
2 458 -82 112 -78 121 -246 17 -307 -69 -40 -232 -15 -316 49 -40 31 -68 29
-72 -3 -7 -45 149 -303 285 -472 37 -47 174 -193 303 -325 311 -318 448 -482
555 -665 117 -200 127 -366 25 -417 -82 -42 -255 31 -463 193 l-92 73 -5 98
c-5 98 -5 98 -32 101 -33 4 -35 -2 -42 -148 -10 -195 -55 -319 -163 -450 -99
-120 -191 -193 -323 -260 -59 -30 -201 -84 -205 -77 -1 1 -27 33 -59 71 -32
38 -70 87 -83 108 -29 43 -67 52 -78 18 -7 -23 4 -43 68 -122 24 -29 79 -98
124 -153 44 -55 119 -135 166 -178 106 -96 157 -164 164 -217 5 -37 2 -43 -38
-84 -52 -51 -95 -66 -197 -66 -234 0 -616 160 -1040 437 -298 194 -435 313
-599 518 -328 410 -492 751 -622 1295 -55 229 -65 334 -66 670 0 271 10 448
31 553 5 25 9 27 54 27 51 0 74 16 68 47 -2 14 -15 19 -56 21 -52 3 -53 4 -48
30 3 15 8 44 12 65 l7 39 42 -6 c79 -12 89 49 12 68 -21 5 -37 15 -37 21 0 27
63 232 100 327 122 306 354 670 478 749 55 35 72 36 99 7z m3379 -3451 c39
-41 59 -73 83 -136 124 -323 80 -581 -139 -802 -141 -144 -284 -198 -513 -199
-184 0 -373 47 -507 126 -102 61 -231 154 -335 243 l-87 73 38 31 c22 16 69
62 105 100 l66 69 29 -37 c87 -111 323 -252 494 -296 239 -60 456 3 582 168
69 91 92 159 91 268 0 78 -5 106 -41 216 -51 152 -53 192 -14 213 15 8 42 15
61 16 29 0 43 -9 87 -53z"
        />
        <path
          d="M3822 4430 c-59 -36 -79 -124 -44 -189 19 -36 72 -71 107 -71 35 0
88 35 107 71 48 91 -12 209 -107 209 -16 0 -45 -9 -63 -20z"
        />
        <path
          d="M2924 4421 c-21 -13 -38 -36 -49 -65 -15 -40 -16 -52 -6 -88 18 -59
63 -98 113 -98 79 0 131 53 131 135 0 107 -102 169 -189 116z"
        />
        <path
          d="M3428 4225 c-84 -47 -14 -124 103 -113 80 8 115 61 68 104 -27 25
-133 30 -171 9z"
        />
        <path
          d="M3345 3752 c-95 -28 -164 -71 -246 -152 -61 -60 -85 -93 -123 -170
-70 -142 -100 -326 -58 -349 32 -17 52 5 52 57 1 252 192 502 421 552 81 18
204 9 262 -19 109 -53 197 -168 197 -258 0 -61 -22 -97 -77 -130 -95 -56 -199
-29 -320 80 -39 37 -57 47 -73 42 -36 -12 -25 -49 31 -98 l52 -45 -17 -49 c-9
-26 -19 -84 -22 -128 -6 -94 7 -130 46 -130 25 0 25 1 25 95 0 110 17 176 44
164 9 -4 41 -14 72 -22 47 -13 65 -14 112 -3 74 16 145 66 175 122 31 58 28
150 -8 224 -35 73 -126 159 -207 198 -61 28 -79 32 -173 34 -77 2 -121 -2
-165 -15z"
        />
      </g>
    </svg>
  );
}
